function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#a166ff;}.cls-2{fill:#232f3e;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-API-Gateway_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Purple_Dark_BG",
  "data-name": "Purple Dark BG",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Product_Icon",
  "data-name": "Product Icon"
}, React.createElement("path", {
  className: "cls-2",
  d: "M48.51,61.5a1,1,0,0,1-.59-.19,1,1,0,0,1-.42-.81v-46a1,1,0,0,1,.48-.85,1,1,0,0,1,1-.05l13,6.35a1,1,0,0,1,.56.89V56.18a1,1,0,0,1-.69,1l-13,4.32A1.19,1.19,0,0,1,48.51,61.5Zm1-45.39v43l11-3.65v-34Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M26.5,61.5a1.19,1.19,0,0,1-.32,0l-13-4.32a1,1,0,0,1-.68-1V20.84a1,1,0,0,1,.56-.89l13-6.35a1,1,0,0,1,1,.05,1,1,0,0,1,.47.85v46a1,1,0,0,1-.42.81A.94.94,0,0,1,26.5,61.5Zm-12-6,11,3.65v-43l-11,5.37Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M47.5,27.5h-3v-2h3Zm-6,0h-3v-2h3Zm-6,0h-3v-2h3Zm-6,0h-3v-2h3Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M47.5,49.5h-3v-2h3Zm-6,0h-3v-2h3Zm-6,0h-3v-2h3Zm-6,0h-3v-2h3Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M33.11,40.94l-3.76-3.21a1,1,0,0,1,0-1.52L33.1,33l1.3,1.52L31.54,37l2.86,2.45Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M41.9,40.94l-1.3-1.52L43.46,37l-2.87-2.44L41.89,33l3.76,3.2a1,1,0,0,1,0,1.52Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 31.29,
  y: 36.5,
  width: 12.41,
  height: 2,
  transform: "translate(-10.04 61) rotate(-71.32)"
})));

var SvgAwsApiGateway = function SvgAwsApiGateway(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsApiGateway, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-API_Gateway.7f8bf3b8.svg";
export { ForwardRef as ReactComponent };